<div>
	<lib-button-list [buttons]="userButtons()"></lib-button-list>
</div>

<lib-card [title]="'Overview'" class="push-top">
	<ui-simple-table [items]="userItems()"></ui-simple-table>
</lib-card>

<lib-card [title]="'Branding'" class="push-top-md">
	<ui-simple-table [items]="brandingItems()"></ui-simple-table>
</lib-card>

<div class="push-top-md">
	@for (tableOverview of tableOverviews(); track tableOverview.id; let first = $first) {
	<lib-card [class.push-top-md]="!first" [title]="tableOverview.title" [titleSuffix]="tableOverview.suffix">
		<lib-table [table]="tableOverview.table"></lib-table>
	</lib-card>
	}
</div>
